import React from 'react';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import './HomeOwnerInsuranceMarketplaceFilter.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox';
import { DropDown } from 'components/form/DropDown';
import { Button } from 'components/form/Button';
import { Image } from 'components/Image/Image';

const HomeInsuranceMarketplaceFilter = props => {
  if (props.showFilters) {
    return (
      <>
        <Row className="margT18 m-margT0">
          <FlexContainer className="align-items-center flex-tablet-col justify-between format100">
            <FlexContainer className="m-flex-column m-format100">
              <TextBox
                id={`${props?.module}-zip`}
                name="zip"
                datatestid={`${props.datatestid}-zipCode`}
                placeholder={'Zip code'}
                value={props.zipCode}
                onChange={e => props.setZipCode(e.target.value)}
                outerClassName={'zipLabel'}
                maxLength={5}
                aria-label={`${props?.module}-zipCode`}
              />
              <DropDown
                id="marital-status"
                datatestid={`${props.datatestid}-marital-status`}
                list={props?.maritalStatus}
                value={props?.currentMaritalStatus}
                onChange={e => props.setCurrentMaritalStatus(e)}
                label={'Marital Status'}
                placeholder={'Marital Status'}
                outerClassName={'margL16 m-margL0'}
              />
              <DropDown
                id="current-insurer"
                datatestid={`${props.datatestid}-current-insurer`}
                list={props.propertyTypes}
                value={props.currentPropertyType}
                onChange={e => props.setCurrentPropertyType(e)}
                label={'Property Type'}
                placeholder={'Property Type'}
                outerClassName={'margL16 m-margL0'}
              />
            </FlexContainer>
            <FlexContainer className="m-format100 m-flex-column m-margT28 m-margl0">
              <Button
                datatestid={`${props.datatestid}-home-offer-get`}
                mrphType="primary"
                onClick={props.onHomeInsuranceSearch}
                className="border-rad100px m-margT0 m-margL0 getQuoteButton"
              >
                <FlexContainer className="justify-center align-items-center">
                  <Label
                    type="Subtitle-2"
                    color="primary_cta_text_light"
                    tabIndex="-1"
                  >
                    {'Update'}
                  </Label>
                </FlexContainer>
              </Button>
              <Row className="text-center m-margT16 d-hide">
                <Label
                  type="caption"
                  color="secondary_text_light"
                  className="text-center m-margB8"
                  bold
                  datatestid={
                    props.datatestid ? `${props.datatestid}-hideFilter` : null
                  }
                >
                  <span
                    className="pointer m-text-14 width100 align-items-center bodyContainer"
                    onClick={() => props.setShowFilters(false)}
                    data-testid="hiHideFilter"
                  >
                    {'Hide Filters'}
                    <Image imgClass={'hideFilterArrowIcon'} />
                  </span>
                </Label>
              </Row>
            </FlexContainer>
          </FlexContainer>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row className="text-center m-margT16 d-hide m-margB20">
        <Label
          type="caption"
          color="secondary_text_light"
          className="text-center"
          bold
          datatestid={
            props.datatestid ? `${props.datatestid}-hideFilter` : null
          }
        >
          <FlexContainer alignItemsCenter>
            <span
              className="pointer t-text-16 width100 align-items-center bodyContainer"
              onClick={() => props.setShowFilters(true)}
              data-testid="hiHideFilter"
            >
              {'Show Filters'}
              <Image imgClass={'showFilterArrowIcon'} />
            </span>
          </FlexContainer>
        </Label>
      </Row>
    </>
  );
};

export default HomeInsuranceMarketplaceFilter;
